import React from 'react';

class ModalRecetaMedidas extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            W: "",
            H: "",
            cantidad: "1"
        };

        this.onConfirm = this.onConfirm.bind(this);
    }

    onConfirm() {
        const { W, H, cantidad } = this.state;
        const wVal = parseFloat(W);
        const hVal = parseFloat(H);
        const cantidadVal = parseInt(cantidad, 10);

        if (isNaN(wVal) || wVal <= 0 || isNaN(hVal) || hVal <= 0 || isNaN(cantidadVal) || cantidadVal <= 0) {
            alert("Por favor ingrese valores válidos mayores a 0 para Ancho, Alto y Cantidad.");
            return;
        }

        this.props.onConfirm(wVal, hVal, this.props.receta, cantidadVal);
    }

    render() {
        const { receta, onCancel } = this.props;

        if (!receta) return null;

        return (
            <div className="m-3">
                <div className="row form-group col-12">
                    <h5>Configurar Receta: {receta.Nombre}</h5>
                </div>
                <div className="row">
                    <div className="col-12 col-md-4 form-group">
                        <label>Ancho (W) en metros</label>
                        <input
                            type="number"
                            step="0.01"
                            min="0"
                            className="form-control"
                            value={this.state.W}
                            onChange={e => this.setState({ W: e.target.value })}
                            placeholder="Ej. 1.50"
                            autoFocus
                        />
                    </div>
                    <div className="col-12 col-md-4 form-group">
                        <label>Alto (H) en metros</label>
                        <input
                            type="number"
                            step="0.01"
                            min="0"
                            className="form-control"
                            value={this.state.H}
                            onChange={e => this.setState({ H: e.target.value })}
                            placeholder="Ej. 2.10"
                        />
                    </div>
                    <div className="col-12 col-md-4 form-group">
                        <label>Cantidad (Uds.)</label>
                        <input
                            type="number"
                            step="1"
                            min="1"
                            className="form-control"
                            value={this.state.cantidad}
                            onChange={e => this.setState({ cantidad: e.target.value })}
                            placeholder="Ej. 3"
                        />
                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col-12 text-right">
                        <button type="button" className="btn btn-secondary mr-2" onClick={onCancel}>
                            Cancelar
                        </button>
                        <button type="button" className="btn btn-primary" onClick={this.onConfirm}>
                            Confirmar y Agregar
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default ModalRecetaMedidas;
